import * as actionTypes from "../constants";

import type { UserFeaturesAvailablePackages, UserFeaturesState } from "../models";

const createEmptyFeaturesState = (isLoading?: boolean): UserFeaturesState => ({
  loading: typeof isLoading !== "undefined" ? isLoading : false,
  error: "",
  packages: null,
});

export const userFeaturesReducer = (state = createEmptyFeaturesState(), action) => {
  switch (action.type) {
    case actionTypes.USER_FEATURES_BEGIN:
      return handleFeaturesBegin();
    case actionTypes.USER_FEATURES_COMPLETED:
      return handleFeaturesCompleted(state, action.payload);
    case actionTypes.USER_FEATURES_ERROR:
      return handleFeaturesError(state, action.payload);
    default:
      return state;
  }
};

const handleFeaturesBegin = (): UserFeaturesState => createEmptyFeaturesState(true);

const handleFeaturesCompleted = (
  state: UserFeaturesState,
  payload: UserFeaturesAvailablePackages,
): UserFeaturesState => ({
  ...state,
  error: "",
  loading: false,
  packages: payload,
});

const handleFeaturesError = (state: UserFeaturesState): UserFeaturesState => ({
  ...state,
  error: "There was an error loading User Features",
  loading: false,
  packages: null,
});
